<template>
	<div class="sf-actions">
		<div className="sf-actions__left">
			<!-- 저장 -->
			<sf-button
				v-if="isButton_(scrId, 'CC') && (((!popupData.calStCd || popupData.calStCd === 'NR') && isMmcUser) || isMmcAdmin)"
				size="sm"
				line
				icon="file"
				:onClick="saveAction"
			>
				{{ getMessage_('QWCC001131') }}
			</sf-button>
			<!-- QR출력 -->
			<sf-button size="sm" v-if="isButton_(scrId, 'CU') && popupData.calStCd && isMmcAdmin" line icon="download" :onClick="printAction">
				{{ getMessage_('QWCC001326') }}
			</sf-button>

			<!-- 回退 -->
			<sf-button size="sm" v-if="isButton_(scrId, 'CC') && popupData.calStCd && isMmcAdmin" line icon="download" :onClick="returnAction">
				{{ getMessage_('QWCC001573') }}
			</sf-button>
			<sf-button size="sm" v-if="isButton_(scrId, 'CD') && popupData.calStCd && isMmcAdmin" line icon="download" :onClick="deleteAction">
				{{ getMessage_('QWCC001136') }}
			</sf-button>
		</div>
	</div>
</template>

<script>
import * as yup from 'yup';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/mmc/mmcm/MesInfo/store/helpers';

export default {
	props: { scrId: { type: String, default: '' } },
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		async reload() {
			this.$sf_toggleLoading(true);
			try {
				const { mesEqipNo } = this.popupData;
				if (mesEqipNo) {
					await this.getHistoryList_({ mesEqipNo }); // 교정이력 목록 조회
					await this.getHisPrbmList_({ mesEqipNo }); // 이상이력 목록 조회
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},

		 returnAction() {
			try {
				// 저장 전 유효성 체크
				this.userSchema.validateSync(this.popupData);
				if (this.isMmcAdmin && this.popupData.eqipKndCd !== 'S') {
					//eqipKndCd  'S' : 장비
					this.adminSchema.validateSync(this.popupData);
				}
				//사양(SPEC) : 장비(S)면 필수
				if (this.popupData.eqipKndCd === 'S' && !this.popupData.spcVal) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001908')]));
				}
				// 기타 유효성 체크
				this.makeValidate(this.popupData);
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: this.reMes }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		deleteAction() {
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001196'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: this.deMes }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		async saveAction() {
			try {
				// 저장 전 유효성 체크
				this.userSchema.validateSync(this.popupData);
				if (this.isMmcAdmin && this.popupData.eqipKndCd !== 'S') {
					//eqipKndCd  'S' : 장비
					this.adminSchema.validateSync(this.popupData);
				}
				//사양(SPEC) : 장비(S)면 필수
				if (this.popupData.eqipKndCd === 'S' && !this.popupData.spcVal) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001908')]));
				}
				// 기타 유효성 체크
				this.makeValidate(this.popupData);
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: this.save }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		async save() {
			try {
				const { header, body } = await this.saveMesInfo_(this.popupData);
				if (header.code === 0) {
					this.$sf_showMessage({
						icon: 'ok',
						message: this.getMessage_(header.messageCd)
					});
					body && this.setState_({ key: 'popupData', value: body });
				} else {
					throw new Error(data?.header?.messageCd);
				}
			} catch (error) {
				console.error(error);
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001533') }); // 오류가 발생했습니다.
			} finally {
				this.$sf_toggleLoading(false);
			}
		},

		async reMes() {
			// try {
			// 	const { header, body } = await this.reMesInfo_(this.popupData);
			// 	if (header.code === 0) {
			// 		this.$sf_showMessage({
			// 			icon: 'ok',
			// 			message: this.getMessage_(header.messageCd)
			// 		});
			// 		body && this.setState_({ key: 'popupData', value: body });
			// 	} else {
			// 		throw new Error(data?.header?.messageCd);
			// 	}
			// } catch (error) {
			// 	console.error(error);
			// 	this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001533') }); // 오류가 발생했습니다.
			// } finally {
			// 	this.$sf_toggleLoading(false);
			// }
			try {
				if (this.popupData.calStCd == 'NR' || this.popupData.calStCd == 'RGST') {
					//교정상태가 [NR 신규]일 경우 [RGST 등록]으로 바꿔준다.
					await this.reMesInfo_(this.popupData);
				}else{
					
				}
				//데이터가 변경된 상태로 팝업을 재오픈한다.
				// this.$emit('open', this.popupData);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		async deMes() {
			this.$sf_toggleLoading(true);
			try {
				await this.deMesInfo_(this.popupData);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}finally {
				this.$sf_toggleLoading(false);
			}
		},
		printAction() {
			//저장(그리드)
			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001777'), //출력하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC001035'), clickFn: this.print }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		async print() {
			/**유비리포트 데이터스트림 가공 시작*/
			let barcodeData = '';
			for (const row of [this.popupData]) {
				if (row.mesEqipNo) {
					const calCyclNm = row.calCyclCd ? _.find(this.calCyclCdList, { value: row.calCyclCd }).label : ' - ';
					barcodeData += row.mesEqipNo + '^t' + calCyclNm + '^t' + row.calCyclCd + '^n';
				} else continue;
			}
			const sendParams = {
				jrfName: 'barcode_kr.jrf',
				streamdata: 'barcode#"' + barcodeData.substring(0, barcodeData.length - 2) + '"'
			};
			this.$emit('openUbiReport', sendParams);
			/**유비리포트 데이터스트림 가공 끝 */

			try {
				if (this.popupData.calStCd == 'NR') {
					//교정상태가 [NR 신규]일 경우 [RGST 등록]으로 바꿔준다.
					const sendData = {
						status: 2,
						data: [this.popupData]
					};
					await this.setCalStCdUpdate_(sendData);
					this.onChangeParam_({ key: 'calStCd', value: 'RGST' });
				}
				//데이터가 변경된 상태로 팝업을 재오픈한다.
				// this.$emit('open', this.popupData);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		makeValidate(pData) {
			const { enMesEqipNm, koMesEqipNm, chMesEqipNm } = pData;
			if (!enMesEqipNm && !koMesEqipNm && !chMesEqipNm) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001314'))); // 장비명은 필수 입력입니다.
			}

			const { mesScpMinVal, mesScpMaxVal } = pData;
			if (mesScpMinVal || mesScpMaxVal) {
				if (Number(mesScpMinVal) >= Number(mesScpMaxVal)) {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001377'))); // 측정범위의 최대값은 최소값보다 높게 입력해야합니다.
				}
			}

			const { lodeMinVal, lodeMaxVal } = pData;
			if (lodeMinVal || lodeMaxVal) {
				if (Number(lodeMinVal) >= Number(lodeMaxVal)) {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001378'))); // 정밀도의 최대값은 최소값보다 높게 입력해야합니다.
				}
			}
		},
		close() {
			this.$emit('ClosePopup', 'close');
		}
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed,
		userSchema() {
			return yup.object().shape({
				eqipKndCd: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001337')])) //{0}은(는) 필수 입력 값 입니다. , 장비종류
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001337')])), //{0}은(는) 필수 입력 값 입니다. , 장비종류
				mdlNm: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001319')])) //{0}은(는) 필수 입력 값 입니다. , 모델명
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001319')])), //{0}은(는) 필수 입력 값 입니다. , 모델명
				enMesEqipNm: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001335')])) //{0}은(는) 필수 입력 값 입니다. , 장비명(영문)
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001335')])), //{0}은(는) 필수 입력 값 입니다. , 장비명(영문)
				chMesEqipNm: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001336')])) //{0}은(는) 필수 입력 값 입니다. , 장비명(영문)
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001336')])), //{0}은(는) 필수 입력 값 입니다. , 장비명(영문)
				useDeptCd: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001321')])) //{0}은(는) 필수 입력 값 입니다. , 사용부서
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001321')])), //{0}은(는) 필수 입력 값 입니다. , 사용부서
				user1Id: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000982')])) //{0}은(는) 필수 입력 값 입니다. , 담당자
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000982')])), //{0}은(는) 필수 입력 값 입니다. , 담당자
				user2Id: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001847')])) //{0}은(는) 필수 입력 값 입니다. , 담당자
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001847')])), //{0}은(는) 필수 입력 값 입니다. , 담당자
				puchDd: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001322')])) //{0}은(는) 필수 입력 값 입니다. , 구입일자
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001322')])) //{0}은(는) 필수 입력 값 입니다. , 구입일자
			});
		},
		adminSchema() {
			return yup.object().shape({
				nextCalDd: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001324')])) //{0}은(는) 필수 입력 값 입니다. , 차기교정일
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001324')])), //{0}은(는) 필수 입력 값 입니다. , 차기교정일
				runStCd: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001315')])) //{0}은(는) 필수 입력 값 입니다. , 가동상태
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001315')])), //{0}은(는) 필수 입력 값 입니다. , 가동상태
				calCyclCd: yup
					.string()
					.nullable()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001323')])) //{0}은(는) 필수 입력 값 입니다. , 교정주기
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001323')])) //{0}은(는) 필수 입력 값 입니다. , 교정주기
			});
		}
	}
};
</script>
